import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

type Props = Omit<AutocompleteProps<string, false, false, false>, "renderInput" | "options" | "value" | "onChange"> & {
  name: string;
  options: string[];
  value: string | null;
  onChange: (event: { target: { name: string; value: string | null } }) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  loading?: boolean;
  width?: number | string;
};

export default function SimpleSingleSelect({
  name,
  options,
  value,
  onChange,
  label = "",
  placeholder = "",
  disabled = false,
  loading = false,
  width = "100%",
  ...otherProps // collect rest props like onBlur, error, etc.
}: Props) {
  return (
    <Box sx={{ width: "100%" }}>
      <Autocomplete
        options={options}
        value={value}
        onChange={(_, newValue) =>
          onChange({
            target: {
              name,
              value: newValue,
            },
          })
        }
        disabled={disabled || loading}
        loading={loading}
        isOptionEqualToValue={(option, val) => option === val}
        {...otherProps} // pass extra props to Autocomplete
        renderInput={(params) => (
          <TextField
            sx={{ ...otherProps.sx, marginBottom: "15px", width: "100%" }}
            {...params}
            name={name} // good to keep on TextField too
            label={label}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
